<section class="after-login">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-strip my-5">
                    <h2 class="text-primary">Saved Booking</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="table-box overflow-hidden">
                    <div class="table-responsive">
                        <table class="table mb-0">
                            <thead>
                                <tr>
                                    <th>Pet name</th>
                                    <th>booking range</th>
                                    <th>action</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (booking of bookings; track booking; let i = $index) {
                                <tr>
                                    <td>
                                        <span>{{ booking?.pet_names }}</span>
                                    </td>
                                    <td>
                                        <span>
                                            {{ booking?.booking_from | date: format }} to
                                            {{ booking?.booking_to | date: format }}
                                        </span>
                                    </td>
                                    <td>
                                        <a (click)="
                                        redirectToBookingPage(
                                          booking
                                        )
                                      " class="text-secondary fs-6 cursor-pointer">
                                            Continue Booking
                                        </a>
                                    </td>
                                </tr>
                                }
                                @empty {
                                <tr class="table-row">
                                    <td colspan="3" class="text-center">No Records to Show!</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        @if (bookings?.length) {
        <div class="custom-pagination">
            <!-- pagination dynamic code put here -->
            <p-paginator #paginat [rows]="paginate.per_page" [totalRecords]="paginate.total"
                (onPageChange)="paginateApply($event)">
            </p-paginator>
        </div>
        }
    </div>
</section>